import AppRouter from "./router";
import { useEffect, useState } from "react";
import { Toaster } from "@/components/ui";
import { notificationApi } from "./features/notifications/services";
import { useNotificationListener } from "@/hooks/useNotificationListener";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "@/lib/queryClient";
import { registerZodErrorMap } from "@mebi/schemas";
import MobileUiProvider from "@/components/layout/MobileUiProvider";

import SplashScreen from "@/components/SplashScreen";
import { systemBarsService } from "@/utils/systemBars";

// Register Zod error map for Vietnamese messages
registerZodErrorMap();

export function AppContent() {
  const [showSplash, setShowSplash] = useState(true);

  // ✅ Setup notification event listeners (React integration)
  useNotificationListener();

  useEffect(() => {
    const initializeApp = async () => {
      // Initialize system bars and notifications concurrently
      try {
        await Promise.allSettled([
          systemBarsService
            .initialize()
            .catch((error) =>
              console.error("❌ SystemBars initialization failed:", error),
            ),
          notificationApi
            .initialize()
            .catch((error) =>
              console.error("❌ NotificationApi initialization failed:", error),
            ),
        ]);
      } catch (error) {
        console.error("❌ Critical initialization error:", error);
      }
    };

    initializeApp();
  }, []);

  // Note: DOM change monitoring is handled by StatusBarManager in router/index.tsx
  // to avoid duplicate observers and improve performance

  // Show splash screen while initializing
  if (showSplash) {
    return (
      <SplashScreen onFinish={() => setShowSplash(false)} duration={2000} />
    );
  }

  return (
    <div className="min-h-screen bg-neutral-100 flex flex-col">
      <AppRouter />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <MobileUiProvider>
      <QueryClientProvider client={queryClient}>
        <AppContent />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </MobileUiProvider>
  );
}

export default App;
